import { toast } from 'sonner'

export default function handleFormSubmitError(isValid: boolean) {
  if (!isValid) {
    toast.error('Проверьте корректность данных', {
      description: 'Некоторые поля заполнены некорректно',
    })
  }
  return undefined
}
